import React from "react";
import Header from "../components/header/Header";
export default function Product() {
  return (
    <div>
      <Header />
      <h1>Product PAGE!!!!</h1>
    </div>
  );
}
